import { frontendURL } from '../../../../helper/URLHelper';

const SECTION_DISPATCHES = 'SECTION_DISPATCHES';
const SECTION_EMAIL = 'SECTION_EMAIL';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: [
    'one_off',
    'ongoing_campaigns',
    'campaigns_suppressions',
    'email_campaigns_domains',
    'email_campaigns_domain_show',
    'email_campaigns_senders',
    'email_campaigns_postal_address',
  ],
  menuItems: [
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'ONE_OFF',
      hasSubMenu: false,
      section: SECTION_DISPATCHES,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    {
      icon: 'arrow-swap',
      label: 'ONGOING',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      section: SECTION_DISPATCHES,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'ongoing_campaigns',
    },
    {
      key: 'emailCampaignDomains',
      icon: 'mail',
      label: 'EMAIL_CAMPAIGNS_DOMAINS',
      hasSubMenu: false,
      section: SECTION_EMAIL,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/domains`
      ),
      toStateName: 'email_campaigns_domains',
      requiresEmailCampaigns: true,
    },
    {
      key: 'emailCampaignSenders',
      icon: 'mail-inbox',
      label: 'EMAIL_CAMPAIGNS_SENDERS',
      hasSubMenu: false,
      section: SECTION_EMAIL,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/senders`
      ),
      toStateName: 'email_campaigns_senders',
      requiresEmailCampaigns: true,
    },
    {
      key: 'campaignSuppressions',
      icon: 'dismiss-circle',
      label: 'EMAIL_CAMPAIGNS_SUPPRESSIONS',
      hasSubMenu: false,
      section: SECTION_EMAIL,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(`accounts/${accountId}/campaigns/suppressions`),
      toStateName: 'campaigns_suppressions',
      requiresEmailCampaigns: true,
    },
    {
      key: 'emailCampaignPostalAddress',
      icon: 'location',
      label: 'EMAIL_CAMPAIGNS_POSTAL_ADDRESS',
      hasSubMenu: false,
      section: SECTION_EMAIL,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/postal-address`
      ),
      toStateName: 'email_campaigns_postal_address',
      requiresEmailCampaigns: true,
    },
  ],
});

export default campaigns;
